<template>
    <div>
         <div class="row justify-content-center">
          <div class="col-md-7" 
            :style="`background-image:url('${$store.state.data.undangan.gambar4}')`"
          style="background:#100001;position:relative;
          background-size:cover;background-repeat:no-repeat;background-position: center center;">
            <!-- <img src="@/static/draw1.jpeg" style="height:130vh;width:100%;position:absolute;right:0;top:0;z-index:10;" alt=""> -->
            <p class=" text-white text-xs " style="position:absolute;bottom:0;right:0;z-index:10000;">Music : <a href="https://www.bensound.com">https://www.bensound.com</a></p>
            <div  v-if="particle" style="height:100%;width:100%;position:absolute;z-index:1000;" id="particlesjspenutup" ></div>
            <br>
            <br>
            <br>
            <div style="height:180px;"></div>
              <div>
                <p class="text-center  font-semibold  text-lg wow"
                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                 style="font-family: 'Urbanist', sans-serif;">
                Atas kehadiran dan do’a restu dari bapak/ibu/saudara/I sekalian, <br> kami mengucapkan Terima Kasih.
                    </p>
                     <!-- <p class=" text-xl font-semibold  text-center" style="letter-spacing: 2px;word-spacing: 2px;font-family: 'Alex Brush', cursive;">
                        Wassalamualaikum Wr. Wb.
                    </p> -->
                      <p class="p-3 text-center text-3xl wow"
                      :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                       style="font-family: 'Amiri', serif;">
                                 وَعَلَيْكُمُ السَّلاَمُ وَرَحْمَةُ اللهِ وَبَرَكَاتُهُ  
                            </p>
                </div>
                <div>
                       <img :src="$store.state.data.undangan.gambar2" style="width:55%;height:55%;display:block;margin:auto;"
                       class="rounded-circle shadow wow"
                       :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                        alt="">
                </div>
                  <p class="text-center  font-semibold  text-lg mt-2 wow"
                  :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                   style="font-family: 'Urbanist', sans-serif;">
                      Kami yang berbahagia
                    </p>
                   <p class=" text-3xl sm:text-5xl  text-center wow"
                   :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                    style="letter-spacing: 4px;word-spacing: 4px;font-family: 'Alex Brush', cursive;">
                                {{$store.state.data.undangan.nama_singkat1}} &
                                {{$store.state.data.undangan.nama_singkat2}}
                            </p>
            <br>
            <br>
            <div style="height:100px;"></div>
          </div>
        </div>
    </div>
</template>
<script>
import 'particles.js'
import axios from "axios";
export default {
  props:['particle'],
  data() {
    return {
     
    };
  },
  components: {
  },
  mounted() {
        window.particlesJS("particlesjspenutup", this.$store.state.particle)
  },
  methods: {
    
  },
};
</script>